<template>
  <div>
    <van-tabs v-model="active" v-show="tabs.length" color="#0278de" :class="tabs.length == 1 ? 'hideTit' : ''">
      <van-tab v-for="(item, index) in tabs" :title="item.name" :key="index">
        <img :src="itemsec" v-for="(itemsec, indexsec) in item.value" class="imgstyData" alt="" v-if="item.name != '宣传片'">
        <div v-else class="videoBox">
          <video :src="itemsec" ref="videoRef" v-for="(itemsec, indexsec) in item.value" controls autoplay loop muted playsinline="true" webkit-playsinline="true"></video>
        </div>
      </van-tab>
    </van-tabs>
<!--    <img src="@/image/backTop.png" class="imgBackTop" :class="sctopInfo.sctop > 48 ? 'imgBackTopadd' : ''" alt="" @click="scToTop">-->
    <div class="backIndex" @click="backindexTab">返回</div>
  </div>
</template>

<script>
import {Shares} from "@/js/share";

export default {
  name: "detail",
  data() {
    let MaCodePPT0 = require(`../imgValue/MACode/01.png`)

    let wdWZ = require(`../imgValue/“五盾”维稳防控工程/文字版.jpg`)
    let wdPPT0 = require(`../imgValue/“五盾”维稳防控工程/PPT版/PPT版_00.png`)
    // let wdPPT1 = require(`../imgValue/“五盾”维稳防控工程/PPT版/PPT版_01.png`)
    let wdVIDEO = require(`../imgValue/“五盾”维稳防控工程/宣传片.mp4`)


    let zdjcWZ = require(`../imgValue/重大决策社会稳定风险评估系统/文字版_00.png`)
    let zdjcPPT0 = require(`../imgValue/重大决策社会稳定风险评估系统/PPT版/PPT版_00.png`)
    // let zdjcPPT1 = require(`../imgValue/重大决策社会稳定风险评估系统/PPT版/PPT版_01.png`)
    let zdjcVIDEO = require(`../imgValue/重大决策社会稳定风险评估系统/宣传片.mp4`)


    let shwwWZ = require(`../imgValue/社会维稳信息管理平台/文字版_00.png`)
    let shwwPPT0 = require(`../imgValue/社会维稳信息管理平台/PPT版/PPT版_00.png`)
    // let shwwPPT1 = require(`../imgValue/社会维稳信息管理平台/PPT版/PPT版_01.png`)

    let zfjcWZ = require(`../imgValue/政府监管燃气安全数智化工程/文字版.jpg`)
    let zfjcPPT0 = require(`../imgValue/政府监管燃气安全数智化工程/PPT版/PPT版_00.png`)
    let zfjcPPT1 = require(`../imgValue/政府监管燃气安全数智化工程/PPT版/PPT版_01.png`)
    // let zfjcPPT2 = require(`../imgValue/政府监管燃气安全数智化工程/PPT版/PPT版_02.png`)
    // let zfjcPPT3 = require(`../imgValue/政府监管燃气安全数智化工程/PPT版/PPT版_03.png`)
    let zfjcVIDEO = require(`../imgValue/政府监管燃气安全数智化工程/宣传片.mp4`)

    let zpjcPPT0 = require(`../imgValue/诈骗检测处置系统/PPT版_00.png`)
    // let zpjcPPT1 = require(`../imgValue/诈骗检测处置系统/PPT版_01.png`)

    let syzlWZ = require(`../imgValue/市域社会治理现代化工程/文字版.jpg`)
    let syzlPPT0 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_00.png`)
    let syzlPPT1 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_01.png`)
    let syzlPPT2 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_02.png`)
    let syzlPPT3 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_03.png`)
    // let syzlPPT4 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_04.png`)
    // let syzlPPT5 = require(`../imgValue/市域社会治理现代化工程/PPT版/PPT版_05.png`)

    let mdjfWZ = require(`../imgValue/矛盾纠纷多元化解/文字版_00.png`)

    let shzdWZ = require(`../imgValue/社会重点人员动态管控/文字版_00.png`)
    let shzdPPT0 = require(`../imgValue/社会重点人员动态管控/PPT版/PPT版_00.png`)
    let shzdPPT1 = require(`../imgValue/社会重点人员动态管控/PPT版/PPT版_01.png`)
    // let shzdPPT2 = require(`../imgValue/社会重点人员动态管控/PPT版/PPT版_02.png`)

    let zhdjWZ = require(`../imgValue/智慧党建管理服务云平台/文字版.jpg`)
    let zhdjPPT0 = require(`../imgValue/智慧党建管理服务云平台/PPT版/PPT版1.png`)
    // let zhdjPPT1 = require(`../imgValue/智慧党建管理服务云平台/PPT版/PPT版2.png`)

    let cssmWZ = require(`../imgValue/城市生命线安全建设工程/文字版_00.png`)

    let qwdWZ = require(`../imgValue/全维度企业服务平台/文字版_00.png`)

    let sqWZ = require(`../imgValue/社区居家养老服务服务平台/文字版.png`)
    let sqPPT0 = require(`../imgValue/社区居家养老服务服务平台/PPT版_00.png`)
    // let sqPPT1 = require(`../imgValue/社区居家养老服务服务平台/PPT版_01.png`)

    let ylWZ = require(`../imgValue/养老机构数字化管理平台/文字版.png`)
    let ylPPT0 = require(`../imgValue/养老机构数字化管理平台/PPT版_00.png`)
    // let ylPPT1 = require(`../imgValue/养老机构数字化管理平台/PPT版_01.png`)

    let zhWZ = require(`../imgValue/智慧助残服务管理平台/文字版.png`)
    let zhPPT0 = require(`../imgValue/智慧助残服务管理平台/ppt版_00.png`)
    return {
      active: 0,
      tabs: [],
      sctopInfo: {
        sctop: 0,
      },
      tabsObj: {
        'MA码+链+AI技术':
            [
              {name: 'PPT版', value: [MaCodePPT0]}
            ],
        '“五盾”维稳防控工程':
            [
              {name: '文字版', value: [wdWZ]},
              {name: 'PPT版', value: [wdPPT0]},
              {name: '宣传片', value: [wdVIDEO]},
            ],
        '重大决策社会稳定风险评估系统':
            [
              {name: '文字版', value: [zdjcWZ]},
              {name: 'PPT版', value: [zdjcPPT0]},
              {name: '宣传片', value: [zdjcVIDEO]},
            ],
        '社会维稳信息管理平台':
            [
              {name: '文字版', value: [shwwWZ]},
              {name: 'PPT版', value: [shwwPPT0]},
            ],
        '政府监管燃气安全数智化工程':
            [
              {name: '文字版', value: [zfjcWZ]},
              {name: 'PPT版', value: [zfjcPPT0, zfjcPPT1]},
              {name: '宣传片', value: [zfjcVIDEO]},
            ],
        '诈骗检测处置系统':
            [
              {name: 'PPT版', value: [zpjcPPT0]},
            ],
        '市域社会治理现代化工程':
            [
              {name: '文字版', value: [syzlWZ]},
              {name: 'PPT版', value: [syzlPPT0, syzlPPT1, syzlPPT2, syzlPPT3]},
            ],
        '矛盾纠纷多元化解':
            [
              {name: '文字版', value: [mdjfWZ]},
            ],
        '社会重点人员动态管控':
            [
              {name: '文字版', value: [shzdWZ]},
              {name: 'PPT版', value: [shzdPPT0, shzdPPT1]},
            ],
        '智慧党建管理服务云平台':
            [
              {name: '文字版', value: [zhdjWZ]},
              {name: 'PPT版', value: [zhdjPPT0]},
            ],
        '城市生命线安全建设工程':
            [
              {name: '文字版', value: [cssmWZ]},
            ],
        '全维度企业服务平台':
            [
              {name: '文字版', value: [qwdWZ]},
            ],
        '社区居家养老服务服务平台':
            [
              {name: '文字版', value: [sqWZ]},
              {name: 'PPT版', value: [sqPPT0]},
            ],
        '养老机构数字化管理平台':
            [
              {name: '文字版', value: [ylWZ]},
              {name: 'PPT版', value: [ylPPT0]},
            ],
        '智慧助残服务管理平台':
            [
              {name: '文字版', value: [zhWZ]},
              {name: 'PPT版', value: [zhPPT0]},
            ],
      }
    }
  },
  'sctopInfo.sctop'(val) {
    // clearTimeout(this.sctimer)
    // console.log(val)
    // if(!val) {
    //   this.hideScale = ''
    //   this.isShowTopFixed = true
    //   return
    // }
    // if(val>40) {
    //   this.hideScale = 'tabListOut'
    // }
    // if(val>110) {
    //   this.hideScale = 'tabListOut,logotext,logoUnderline'
    // }
    // if(val>168) {
    //   this.hideScale = 'logoImg,tabListOut,logotext,logoUnderline'
    // }
  },
  watch: {
    'active' (val, oldval) {
      if(oldval==2){
        console.log(this.$refs.videoRef)
        this.$refs.videoRef[0].pause()
      }
    }
  },
  mounted() {
    const param = this.$route.query
    this.tabs = [...this.tabsObj[param.title]]
    document.title = param.title
    let imgurl = 'https://xztys.goldweb.cn/img/shareImg.jpg'
    let title = param.title
    let desc = '点击查看详情'
    let link = window.location.href
    console.log(imgurl, title, desc, link)
    Shares.shareCode(imgurl, title, desc, link, (status,data) => {
      if(status === 'success') {
        console.log('success')// 分享成功的操作
      } else if(status === 'cancel') {
        console.log('error')// 分享失败的操作
      }
    })
    window.addEventListener('scroll', this.scrollSet);
  },
  methods: {
    scrollSet() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.$set(this.sctopInfo, 'sctop', scrollTop)
    },
    scToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    backindexTab() {
      this.$router.replace('/')
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollSet)
    if(this.active == 2) this.$refs.videoRef[0].pause()
  }
}
</script>
<style scoped>
.hideTit /deep/ .van-tabs__wrap{
  height: 0 !important;
  opacity: 0;
}
.hideTit /deep/ .van-tabs__content{
  padding-top: 0;
}
/deep/ .van-tabs--line .van-tabs__wrap {
  height: 1.17333rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
}
/deep/ .van-tabs__content{
  padding-top: 42px;
}
</style>
<style scoped lang="less">
.imgstyData{
  max-width: 100%;
  width: 100%;
}
.videoBox{
  width: 100%;
  height: calc(100vh - 45px);
  background-color: #000020;
  background-image: url("~@/image/topweb.png");
  background-size: 200% 180%;
  background-repeat: repeat-y;

  background-attachment: fixed;
  background-position: 68% 20%;
  position: relative;
  display: flex;
  align-items: center;
  >video{
    max-width: 100%;
    width: 100%;
    position: relative;
    top: -45px;
  }
}
.imgBackTop{
  width: 82px;
  position: fixed;
  right: 0;
  height: 84px;
  bottom: 48px;
  z-index: -1;
  opacity: 0;
  transition: all .5s ease;
}
.imgBackTopadd{
  bottom: 28px;
  opacity: 1;
  z-index: 1;
}
.backIndex{
  position: fixed;
  bottom: 48px;
  right: 10px;
  width: 49px;
  height: 49px;
  z-index: 1;
  background-image: url("~@/image/backIndex.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding-top: 29px;
  text-align: center;
  font-size: 12px;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  font-weight: bold;
}
</style>